var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "groupItems"
  }, [_vm.item.partsType === "singleLine" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.item.controlName || _vm.$t("控件名称")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item.controlExplain) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.item.prefix)))]), _c("a-input", {
    style: {
      width: _vm.item.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.item.promptText),
      readOnly: true
    }
  }), _c("span", [_vm._v(_vm._s(_vm.$t(_vm.item.suffix)))])], 1)], 1), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 500
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.item, "promptText", $$v);
      },
      expression: "item.promptText"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("div", {
    staticClass: "nav_item_q ml_28"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("前缀"),
      prop: "qianzhui"
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.prefix,
      callback: function ($$v) {
        _vm.$set(_vm.item, "prefix", $$v);
      },
      expression: "item.prefix"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain ml_32"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("后缀"),
      prop: "suffix"
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.suffix,
      callback: function ($$v) {
        _vm.$set(_vm.item, "suffix", $$v);
      },
      expression: "item.suffix"
    }
  })], 1)], 1)]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("属性校验")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    model: {
      value: _vm.item.attributeVerification,
      callback: function ($$v) {
        _vm.$set(_vm.item, "attributeVerification", $$v);
      },
      expression: "item.attributeVerification"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: _vm.$t("单行文本"),
      value: "SINGLE_LINE"
    }
  }, [_vm._v(_vm._s(_vm.$t("单行文本")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("数字"),
      value: "NUMBER"
    }
  }, [_vm._v(_vm._s(_vm.$t("数字")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("手机号"),
      value: "PHONE"
    }
  }, [_vm._v(_vm._s(_vm.$t("手机号")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("身份证号"),
      value: "IDCODE"
    }
  }, [_vm._v(_vm._s(_vm.$t("身份证号")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("身份证号"),
      value: "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("邮箱")))])], 1)], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_vm.item.attributeVerification === "NUMBER" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("小数点位数")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      "controls-position": "right",
      min: 0,
      max: 5
    },
    on: {
      blur: function ($event) {
        return _vm.xsdDefault1(_vm.index);
      }
    },
    model: {
      value: _vm.item.decimalPlaces,
      callback: function ($$v) {
        _vm.$set(_vm.item, "decimalPlaces", $$v);
      },
      expression: "item.decimalPlaces"
    }
  })], 1) : _vm._e()], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_vm.item.attributeVerification === "NUMBER" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("数值限制")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      "controls-position": "right",
      min: 0,
      max: 40000000
    },
    on: {
      blur: function ($event) {
        return _vm.szxzNumberMIN(_vm.index);
      },
      change: _vm.updateNumberMaxValue
    },
    model: {
      value: _vm.item.numberMinValue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "numberMinValue", $$v);
      },
      expression: "item.numberMinValue"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("至")) + " "), _c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      "controls-position": "right",
      min: _vm.item.numberMinValue,
      max: 40000000
    },
    on: {
      blur: function ($event) {
        return _vm.szxzNumberMAX(_vm.index);
      }
    },
    model: {
      value: _vm.item.numberMaxValue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "numberMaxValue", $$v);
      },
      expression: "item.numberMaxValue"
    }
  })], 1) : _vm._e()], 1)]), _c("div", {
    on: {
      click: function ($event) {
        return _vm.minMaxNav(_vm.index);
      }
    }
  }, [_vm.item.attributeVerification === "SINGLE_LINE" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("字数限制")
    }
  }, [_c("a-input-number", {
    attrs: {
      "controls-position": "right",
      min: 0,
      max: 199
    },
    on: {
      blur: function ($event) {
        return _vm.zsxzDefault1(_vm.index);
      }
    },
    model: {
      value: _vm.item.textMinLength,
      callback: function ($$v) {
        _vm.$set(_vm.item, "textMinLength", $$v);
      },
      expression: "item.textMinLength"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("至")) + " "), _c("a-input-number", {
    attrs: {
      "controls-position": "right",
      min: _vm.item.textMinLength + 1,
      max: 200
    },
    on: {
      blur: function ($event) {
        return _vm.zsxzDefault2(_vm.index);
      }
    },
    model: {
      value: _vm.item.textMaxLength,
      callback: function ($$v) {
        _vm.$set(_vm.item, "textMaxLength", $$v);
      },
      expression: "item.textMaxLength"
    }
  })], 1) : _vm._e()], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宽度限制")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择宽度")
    },
    model: {
      value: _vm.item.widthSet,
      callback: function ($$v) {
        _vm.$set(_vm.item, "widthSet", $$v);
      },
      expression: "item.widthSet"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: "10%",
      value: 10
    }
  }, [_vm._v(_vm._s(_vm.$t("10%")))]), _c("a-select-option", {
    attrs: {
      label: "20%",
      value: 20
    }
  }, [_vm._v(_vm._s(_vm.$t("20%")))]), _c("a-select-option", {
    attrs: {
      label: "30%",
      value: 30
    }
  }, [_vm._v(_vm._s(_vm.$t("30%")))]), _c("a-select-option", {
    attrs: {
      label: "40%",
      value: 40
    }
  }, [_vm._v(_vm._s(_vm.$t("40%")))]), _c("a-select-option", {
    attrs: {
      label: "50%",
      value: 50
    }
  }, [_vm._v(_vm._s(_vm.$t("50%")))]), _c("a-select-option", {
    attrs: {
      label: "60%",
      value: 60
    }
  }, [_vm._v(_vm._s(_vm.$t("60%")))]), _c("a-select-option", {
    attrs: {
      label: "70%",
      value: 70
    }
  }, [_vm._v(_vm._s(_vm.$t("70%")))]), _c("a-select-option", {
    attrs: {
      label: "80%",
      value: 80
    }
  }, [_vm._v(_vm._s(_vm.$t("80%")))]), _c("a-select-option", {
    attrs: {
      label: "90%",
      value: 90
    }
  }, [_vm._v(_vm._s(_vm.$t("90%")))]), _c("a-select-option", {
    attrs: {
      label: "100%",
      value: 100
    }
  }, [_vm._v(_vm._s(_vm.$t("100%")))])], 1)], 1)], 1), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      "margin-left": "20px",
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e()]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)])])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {}, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()] : _vm.item.partsType === "multiline" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.item.controlName || _vm.$t("控件名称")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item.controlExplain) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("a-input", {
    style: {
      width: _vm.item.widthSet
    },
    attrs: {
      type: "textarea",
      placeholder: _vm.$t(_vm.item.promptText),
      readOnly: true
    }
  })], 1)], 1), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置：")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 15
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.item, "promptText", $$v);
      },
      expression: "item.promptText"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值：")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("div", {
    staticClass: "number_value"
  }, [_c("div", {
    staticClass: "flex_1"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("字数限制")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      min: 0
    },
    on: {
      blur: _vm.multilineMIN
    },
    model: {
      value: _vm.item.minWordCount,
      callback: function ($$v) {
        _vm.$set(_vm.item, "minWordCount", $$v);
      },
      expression: "item.minWordCount"
    }
  }), _vm._v(" —— "), _c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      min: _vm.item.minWordCount + 1
    },
    on: {
      blur: _vm.multilineMAX
    },
    model: {
      value: _vm.item.maxWordCount,
      callback: function ($$v) {
        _vm.$set(_vm.item, "maxWordCount", $$v);
      },
      expression: "item.maxWordCount"
    }
  })], 1)], 1), _c("div", {
    staticClass: "flex_1"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宽度限制")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择宽度")
    },
    model: {
      value: _vm.item.widthSet,
      callback: function ($$v) {
        _vm.$set(_vm.item, "widthSet", $$v);
      },
      expression: "item.widthSet"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: "10%",
      value: 10
    }
  }, [_vm._v(_vm._s(_vm.$t("10%")))]), _c("a-select-option", {
    attrs: {
      label: "20%",
      value: 20
    }
  }, [_vm._v(_vm._s(_vm.$t("20%")))]), _c("a-select-option", {
    attrs: {
      label: "30%",
      value: 30
    }
  }, [_vm._v(_vm._s(_vm.$t("30%")))]), _c("a-select-option", {
    attrs: {
      label: "40%",
      value: 40
    }
  }, [_vm._v(_vm._s(_vm.$t("40%")))]), _c("a-select-option", {
    attrs: {
      label: "50%",
      value: 50
    }
  }, [_vm._v(_vm._s(_vm.$t("50%")))]), _c("a-select-option", {
    attrs: {
      label: "60%",
      value: 60
    }
  }, [_vm._v(_vm._s(_vm.$t("60%")))]), _c("a-select-option", {
    attrs: {
      label: "70%",
      value: 70
    }
  }, [_vm._v(_vm._s(_vm.$t("70%")))]), _c("a-select-option", {
    attrs: {
      label: "80%",
      value: 80
    }
  }, [_vm._v(_vm._s(_vm.$t("80%")))]), _c("a-select-option", {
    attrs: {
      label: "90%",
      value: 90
    }
  }, [_vm._v(_vm._s(_vm.$t("90%")))]), _c("a-select-option", {
    attrs: {
      label: "100%",
      value: 100
    }
  }, [_vm._v(_vm._s(_vm.$t("100%")))])], 1)], 1)], 1)]), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e()]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)])])]), _c("div", [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他：")))]), _c("div", {
    staticClass: "nav_50"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1)]), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()] : _vm.item.partsType === "singleChoice" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.item.controlName || _vm.$t("控件名称")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item.controlExplain) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("el-row", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      gutter: 20
    }
  }, _vm._l(_vm.item.controlValue, function (item1, index1) {
    return _c("el-col", {
      key: index1,
      attrs: {
        span: _vm.item.sortWay.type === "TRANSVERSE" ? Math.floor(24 / _vm.item.sortWay.value) : 24
      }
    }, [_c("el-radio", {
      staticStyle: {
        height: "40px"
      },
      attrs: {
        label: item1.name
      },
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.handleOptionClick(item1, _vm.index);
        }
      },
      model: {
        value: _vm.item.selectedOption,
        callback: function ($$v) {
          _vm.$set(_vm.item, "selectedOption", $$v);
        },
        expression: "item.selectedOption"
      }
    }, [_vm._v(_vm._s(item1.name))]), item1.isWrite && (item1.name === _vm.item.selectedOption || item1.showInput) ? _c("el-input", {
      staticStyle: {
        width: "60px",
        height: "100%"
      },
      attrs: {
        size: "small"
      },
      model: {
        value: _vm.item.emptyValue,
        callback: function ($$v) {
          _vm.$set(_vm.item, "emptyValue", $$v);
        },
        expression: "item.emptyValue"
      }
    }) : _vm._e()], 1);
  }), 1)], 1), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 500
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("div", {
    staticClass: "radio-control"
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.item.controlValue,
      border: true
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "name",
      label: "选项值"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input", {
          model: {
            value: scope.row.name,
            callback: function ($$v) {
              _vm.$set(scope.row, "name", $$v);
            },
            expression: "scope.row.name"
          }
        })];
      }
    }], null, false, 3360424494)
  }), _c("el-table-column", {
    attrs: {
      prop: "isWrite",
      label: _vm.$t("允许填空")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-checkbox", {
          model: {
            value: scope.row.isWrite,
            callback: function ($$v) {
              _vm.$set(scope.row, "isWrite", $$v);
            },
            expression: "scope.row.isWrite"
          }
        })];
      }
    }], null, false, 2405673003)
  }), _c("el-table-column", {
    attrs: {
      label: _vm.$t("操作")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button-group", [scope.$index === 0 ? _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.addOptionDA(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("添加")))]) : _vm._e(), _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary",
            disabled: scope.$index === 0
          },
          on: {
            click: function ($event) {
              return _vm.moveUpDA(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("上移")))]), _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary",
            disabled: scope.$index === _vm.item.controlValue.length - 1
          },
          on: {
            click: function ($event) {
              return _vm.moveDownDA(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("下移")))]), _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary",
            disabled: _vm.item.controlValue.length === 1
          },
          on: {
            click: function ($event) {
              return _vm.deleteOptionDA(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])], 1)];
      }
    }], null, false, 1523550149)
  })], 1), _vm.item.controlValue.length === 0 || _vm.item.controlValue[_vm.item.controlValue.length - 1].selected ? _c("el-row", {
    staticClass: "add-option-row"
  }, [_c("el-button", {
    attrs: {
      icon: "el-icon-plus",
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.addOptionDA(_vm.item.controlValue.length);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("添加选项")))])], 1) : _vm._e()], 1), _c("div", {
    staticClass: "number_value",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("div", {
    staticClass: "flex_1"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("排列方式")
    }
  }, [_c("a-select", {
    staticClass: "layout-select",
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: "请选择排列方式"
    },
    model: {
      value: _vm.item.sortWay.type,
      callback: function ($$v) {
        _vm.$set(_vm.item.sortWay, "type", $$v);
      },
      expression: "item.sortWay.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "VERTICAL"
    }
  }, [_vm._v(_vm._s(_vm.$t("竖向排列")))]), _c("a-select-option", {
    attrs: {
      value: "TRANSVERSE"
    }
  }, [_vm._v(_vm._s(_vm.$t("横向排列")))])], 1)], 1)], 1), _vm.item.sortWay.type === "TRANSVERSE" ? _c("div", {
    staticClass: "flex_1"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("每行列数：")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择每行列数")
    },
    model: {
      value: _vm.item.sortWay.value,
      callback: function ($$v) {
        _vm.$set(_vm.item.sortWay, "value", $$v);
      },
      expression: "item.sortWay.value"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行1列")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行2列")))]), _c("a-select-option", {
    attrs: {
      value: "3"
    }
  }, [_vm._v(_vm._s(_vm.$t("每行3列")))])], 1)], 1)], 1) : _vm._e()]), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e()]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)])]), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {
    staticClass: "number_value"
  }, [_c("div", {
    staticClass: "flex_1",
    staticStyle: {
      "margin-left": "34px"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "flex_1"
  }, [_c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宏样式"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.macroStyle,
      callback: function ($$v) {
        _vm.$set(_vm.item, "macroStyle", $$v);
      },
      expression: "item.macroStyle"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "ALL"
    }
  }, [_vm._v(_vm._s(_vm.$t("展示全部选项")))]), _c("a-radio", {
    attrs: {
      value: "Selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("仅展示选中选项")))])], 1)], 1)], 1)])])]), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()] : _vm.item.partsType === "multipleChoice" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.item.controlName || _vm.$t("控件名称")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item.controlExplain) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("el-row", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      gutter: 20
    }
  }, _vm._l(_vm.item.controlValue, function (item2) {
    return _c("el-col", {
      key: item2.name,
      attrs: {
        value: item2.name,
        span: _vm.item.sortWay.type === "TRANSVERSE" ? Math.floor(24 / _vm.item.sortWay.value) : 24
      }
    }, [_c("el-checkbox", {
      staticStyle: {
        height: "40px"
      },
      attrs: {
        label: item2.name
      },
      on: {
        change: function ($event) {
          return _vm.handleOptionChange(item2, _vm.index);
        }
      },
      model: {
        value: _vm.item.selectedOptionsDX,
        callback: function ($$v) {
          _vm.$set(_vm.item, "selectedOptionsDX", $$v);
        },
        expression: "item.selectedOptionsDX"
      }
    }, [_vm._v(" " + _vm._s(item2.name) + " ")]), item2.isWrite && _vm.item.selectedOptionsDX.includes(item2.name) ? _c("el-input", {
      staticStyle: {
        width: "60px",
        height: "100%"
      },
      attrs: {
        size: "small"
      },
      model: {
        value: item2.emptyValue,
        callback: function ($$v) {
          _vm.$set(item2, "emptyValue", $$v);
        },
        expression: "item2.emptyValue"
      }
    }) : _vm._e()], 1);
  }), 1)], 1)], 1), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 500
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("div", {
    staticClass: "radio-control"
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.item.controlValue,
      border: true
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "name",
      label: _vm.$t("选项值")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input", {
          model: {
            value: scope.row.name,
            callback: function ($$v) {
              _vm.$set(scope.row, "name", $$v);
            },
            expression: "scope.row.name"
          }
        })];
      }
    }], null, false, 3360424494)
  }), _c("el-table-column", {
    attrs: {
      prop: "isWrite",
      label: _vm.$t("允许填空")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-checkbox", {
          model: {
            value: scope.row.isWrite,
            callback: function ($$v) {
              _vm.$set(scope.row, "isWrite", $$v);
            },
            expression: "scope.row.isWrite"
          }
        })];
      }
    }], null, false, 2405673003)
  }), _c("el-table-column", {
    attrs: {
      label: _vm.$t("操作")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button-group", [scope.$index === 0 ? _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.addOptionDX(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("添加")))]) : _vm._e(), _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary",
            disabled: scope.$index === 0
          },
          on: {
            click: function ($event) {
              return _vm.moveUpDX(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("上移")))]), _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary",
            disabled: scope.$index === _vm.item.controlValue.length - 1
          },
          on: {
            click: function ($event) {
              return _vm.moveDownDX(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("下移")))]), _c("el-button", {
          staticClass: "title_but button_dx",
          attrs: {
            type: "primary",
            disabled: _vm.item.controlValue.length === 1
          },
          on: {
            click: function ($event) {
              return _vm.deleteOptionDX(scope.$index, _vm.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])], 1)];
      }
    }], null, false, 1154769253)
  })], 1)], 1), _c("div", {}, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选项数量")
    }
  }, [_c("a-input-number", {
    attrs: {
      mix: _vm.item.numberLimit1,
      max: _vm.item.numberLimit2
    },
    on: {
      change: function ($event) {
        return _vm.handleNumberLimit1Change(_vm.index);
      }
    },
    model: {
      value: _vm.item.numberLimit1,
      callback: function ($$v) {
        _vm.$set(_vm.item, "numberLimit1", $$v);
      },
      expression: "item.numberLimit1"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("--")) + " "), _c("a-input-number", {
    attrs: {
      mix: _vm.item.numberLimit2
    },
    model: {
      value: _vm.item.numberLimit2,
      callback: function ($$v) {
        _vm.$set(_vm.item, "numberLimit2", $$v);
      },
      expression: "item.numberLimit2"
    }
  })], 1)], 1), _c("div", {
    staticClass: "number_value",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("div", {
    staticClass: "flex_1"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("排列方式")
    }
  }, [_c("a-select", {
    staticClass: "layout-select",
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: "请选择排列方式"
    },
    model: {
      value: _vm.item.sortWay.type,
      callback: function ($$v) {
        _vm.$set(_vm.item.sortWay, "type", $$v);
      },
      expression: "item.sortWay.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "VERTICAL"
    }
  }, [_vm._v(_vm._s(_vm.$t("竖向排列")))]), _c("a-select-option", {
    attrs: {
      value: "TRANSVERSE"
    }
  }, [_vm._v(_vm._s(_vm.$t("横向排列")))])], 1)], 1)], 1), _vm.item.sortWay.type === "TRANSVERSE" ? _c("div", {
    staticClass: "flex_1"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("每行列数：")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择每行列数")
    },
    model: {
      value: _vm.item.sortWay.value,
      callback: function ($$v) {
        _vm.$set(_vm.item.sortWay, "value", $$v);
      },
      expression: "item.sortWay.value"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: _vm.$t("1")
    }
  }, [_vm._v(_vm._s(_vm.$t("每行1列")))]), _c("a-select-option", {
    attrs: {
      value: _vm.$t("2")
    }
  }, [_vm._v(_vm._s(_vm.$t("每行2列")))]), _c("a-select-option", {
    attrs: {
      value: _vm.$t("3")
    }
  }, [_vm._v(_vm._s(_vm.$t("每行3列")))])], 1)], 1)], 1) : _vm._e()]), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e()]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)])]), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {
    staticClass: "number_value"
  }, [_c("div", {
    staticClass: "flex_1",
    staticStyle: {
      "margin-left": "34px"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "flex_1"
  }, [_c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宏样式"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.macroStyle,
      callback: function ($$v) {
        _vm.$set(_vm.item, "macroStyle", $$v);
      },
      expression: "item.macroStyle"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "All"
    }
  }, [_vm._v(_vm._s(_vm.$t("展示全部选项")))]), _c("a-radio", {
    attrs: {
      value: "Selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("仅展示选中选项")))])], 1)], 1)], 1)])])]), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()] : _vm.item.partsType === "dropDown" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.item.controlName || _vm.$t("控件名称")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item.controlExplain) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("a-form-model-item", [_c("el-cascader", {
    style: {
      width: _vm.item.widthSet
    },
    attrs: {
      placeholder: _vm.item.promptText,
      options: _vm.item.Customvalues,
      props: _vm.propsTree
    },
    on: {
      change: function ($event) {
        return _vm.handleCascaderChange(_vm.value);
      }
    },
    model: {
      value: _vm.item.selectedValues,
      callback: function ($$v) {
        _vm.$set(_vm.item, "selectedValues", $$v);
      },
      expression: "item.selectedValues"
    }
  })], 1)], 1)], 1), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置：")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 15
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.item, "promptText", $$v);
      },
      expression: "item.promptText"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值")))]), _c("div", {
    staticClass: "margin_lf_30"
  }, [_c("div", {
    staticClass: "nav_xl"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件类型")
    }
  }, [_c("a-radio-group", {
    on: {
      change: function ($event) {
        return _vm.customClickVue(_vm.item.type.type, _vm.index);
      }
    },
    model: {
      value: _vm.item.type.type,
      callback: function ($$v) {
        _vm.$set(_vm.item.type, "type", $$v);
      },
      expression: "item.type.type"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "country"
    }
  }, [_vm._v(_vm._s(_vm.$t("国家")))]), _c("a-radio", {
    attrs: {
      value: "provinceFirstLevel"
    }
  }, [_vm._v(_vm._s(_vm.$t("省")))]), _c("a-radio", {
    attrs: {
      value: "province"
    }
  }, [_vm._v(_vm._s(_vm.$t("省市")))]), _c("a-radio", {
    attrs: {
      value: "provinceArea"
    }
  }, [_vm._v(_vm._s(_vm.$t("省市区")))]), _c("a-radio", {
    attrs: {
      value: "bank"
    }
  }, [_vm._v(_vm._s(_vm.$t("开户行")))]), _c("a-radio", {
    attrs: {
      value: "logistics"
    }
  }, [_vm._v(_vm._s(_vm.$t("物流")))]), _c("a-radio", {
    attrs: {
      value: "profession"
    }
  }, [_vm._v(_vm._s(_vm.$t("职业")))]), _c("a-radio", {
    attrs: {
      value: "custom"
    }
  }, [_vm._v(_vm._s(_vm.$t("自定义")))])], 1)], 1)], 1), _vm.visiblecustom ? _c("div", {
    staticClass: "zdy_amode",
    staticStyle: {
      width: "900px",
      "margin-left": "-22px",
      "margin-bottom": "20px"
    }
  }, [_c("div", {
    staticStyle: {
      width: "850px",
      "overflow-y": "auto"
    }
  }, [_c("customModel", {
    attrs: {
      itemmark: _vm.item.mark,
      index: _vm.index,
      "form-data-array": _vm.formDataArray
    },
    on: {
      "tree-list": _vm.treelist
    }
  })], 1)]) : _vm._e(), _c("div", {
    staticClass: "dx_lf_30"
  }, [_c("div", {
    staticClass: "dx_a"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否多选")
    }
  }, [_c("a-radio-group", {
    on: {
      change: function ($event) {
        return _vm.MultipleShow(_vm.item);
      }
    },
    model: {
      value: _vm.item.isMultipleChoice,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isMultipleChoice", $$v);
      },
      expression: "item.isMultipleChoice"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1), _c("div", {
    staticClass: "dx_a"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)]), _c("div", {}, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宽度限制")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择宽度")
    },
    model: {
      value: _vm.item.widthSet,
      callback: function ($$v) {
        _vm.$set(_vm.item, "widthSet", $$v);
      },
      expression: "item.widthSet"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: "50%",
      value: 50
    }
  }, [_vm._v(_vm._s(_vm.$t("50%")))]), _c("a-select-option", {
    attrs: {
      label: "60%",
      value: 60
    }
  }, [_vm._v(_vm._s(_vm.$t("60%")))]), _c("a-select-option", {
    attrs: {
      label: "70%",
      value: 70
    }
  }, [_vm._v(_vm._s(_vm.$t("70%")))]), _c("a-select-option", {
    attrs: {
      label: "80%",
      value: 80
    }
  }, [_vm._v(_vm._s(_vm.$t("80%")))]), _c("a-select-option", {
    attrs: {
      label: "90%",
      value: 90
    }
  }, [_vm._v(_vm._s(_vm.$t("90%")))]), _c("a-select-option", {
    attrs: {
      label: "100%",
      value: 100
    }
  }, [_vm._v(_vm._s(_vm.$t("100%")))])], 1)], 1)], 1)]), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他：")))]), _c("div", {
    staticClass: "nav_50"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()] : _vm.item.partsType === "date" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.item.controlName || _vm.$t("控件名称")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item.controlExplain) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("a-input", {
    style: {
      width: _vm.item.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.item.promptText),
      readOnly: true
    }
  })], 1)], 1), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 500
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.item, "promptText", $$v);
      },
      expression: "item.promptText"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件格式"),
      prop: "dateType",
      rules: [{
        required: true
      }]
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "315px"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    model: {
      value: _vm.item.dateType,
      callback: function ($$v) {
        _vm.$set(_vm.item, "dateType", $$v);
      },
      expression: "item.dateType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "YYYY-MM-DD"
    }
  }, [_vm._v(_vm._s(_vm.$t("yyyy-MM-dd")))]), _c("a-select-option", {
    attrs: {
      value: "YYYY-MM-DD HH:mm:ss"
    }
  }, [_vm._v(_vm._s(_vm.$t("yyyy-MM-dd HH:mm:ss")))])], 1)], 1)], 1), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)])]), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      flex: "none",
      "margin-right": "10px"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("开始时间"),
      rules: [{
        required: true
      }]
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "120px"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: function ($event) {
        return _vm.timeSelectChange(_vm.item.dateStart, "start");
      }
    },
    model: {
      value: _vm.item.dateStart.type,
      callback: function ($$v) {
        _vm.$set(_vm.item.dateStart, "type", $$v);
      },
      expression: "item.dateStart.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: _vm.$t("无限制"),
      value: "UNLIMITED"
    }
  }, [_vm._v(_vm._s(_vm.$t("无限制")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("特定时间"),
      value: "SPECIFIC_TIME"
    }
  }, [_vm._v(_vm._s(_vm.$t("特定时间")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("当前时间前"),
      value: "TIME_FRONT"
    }
  }, [_vm._v(_vm._s(_vm.$t("当前时间前")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("当前时间后"),
      value: "TIME_AFTER"
    }
  }, [_vm._v(_vm._s(_vm.$t("当前时间后")))])], 1)], 1)], 1), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm.item.dateStart.type === "SPECIFIC_TIME" ? _c("div", [_c("a-date-picker", {
    staticStyle: {
      "min-width": "185px !important",
      width: "185px"
    },
    attrs: {
      format: _vm.item.dateType,
      "show-time": _vm.item.dateType === "YYYY-MM-DD HH:mm:ss" ? {
        format: "HH:mm:ss"
      } : null
    },
    model: {
      value: _vm.item.dateStart.value,
      callback: function ($$v) {
        _vm.$set(_vm.item.dateStart, "value", $$v);
      },
      expression: "item.dateStart.value"
    }
  })], 1) : _vm._e(), _vm.item.dateStart.type === "TIME_FRONT" || _vm.item.dateStart.type === "TIME_AFTER" ? _c("div", [_c("a-input-number", {
    attrs: {
      min: 0,
      max: 365
    },
    model: {
      value: _vm.relativeTime,
      callback: function ($$v) {
        _vm.relativeTime = $$v;
      },
      expression: "relativeTime"
    }
  }), _c("a-select", {
    staticStyle: {
      width: "60px"
    },
    model: {
      value: _vm.item.dateStart.unit,
      callback: function ($$v) {
        _vm.$set(_vm.item.dateStart, "unit", $$v);
      },
      expression: "item.dateStart.unit"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: _vm.$t("日"),
      value: "DAY"
    }
  }, [_vm._v(_vm._s(_vm.$t("日")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("月"),
      value: "MONTH"
    }
  }, [_vm._v(_vm._s(_vm.$t("月")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("年"),
      value: "YEAR"
    }
  }, [_vm._v(_vm._s(_vm.$t("年")))])], 1)], 1) : _vm._e()])])]), _c("div", {
    staticClass: "nav_qain"
  }, [_c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      flex: "none",
      "margin-right": "10px"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("结束时间"),
      rules: [{
        required: true
      }]
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "120px"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: function ($event) {
        return _vm.timeSelectChange(_vm.item.dateEnd);
      }
    },
    model: {
      value: _vm.item.dateEnd.type,
      callback: function ($$v) {
        _vm.$set(_vm.item.dateEnd, "type", $$v);
      },
      expression: "item.dateEnd.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: _vm.$t("无限制"),
      value: "UNLIMITED"
    }
  }, [_vm._v(_vm._s(_vm.$t("无限制")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("特定时间"),
      value: "SPECIFIC_TIME"
    }
  }, [_vm._v(_vm._s(_vm.$t("特定时间")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("当前时间前"),
      value: "TIME_FRONT"
    }
  }, [_vm._v(_vm._s(_vm.$t("当前时间前")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("当前时间后"),
      value: "TIME_AFTER"
    }
  }, [_vm._v(_vm._s(_vm.$t("当前时间后")))])], 1)], 1)], 1), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm.item.dateEnd.type === "SPECIFIC_TIME" ? _c("div", [_c("a-date-picker", {
    staticStyle: {
      "min-width": "185px !important",
      width: "185px"
    },
    attrs: {
      format: _vm.item.dateType,
      "show-time": _vm.item.dateType === "YYYY-MM-DD HH:mm:ss" ? {
        format: "HH:mm:ss"
      } : null
    },
    model: {
      value: _vm.item.dateEnd.value,
      callback: function ($$v) {
        _vm.$set(_vm.item.dateEnd, "value", $$v);
      },
      expression: "item.dateEnd.value"
    }
  })], 1) : _vm._e(), _vm.item.dateEnd === "TIME_FRONT" || _vm.item.dateEnd === "TIME_AFTER" ? _c("div", [_c("a-input-number", {
    attrs: {
      min: 0,
      max: 365
    },
    model: {
      value: _vm.relativeTime,
      callback: function ($$v) {
        _vm.relativeTime = $$v;
      },
      expression: "relativeTime"
    }
  }), _c("a-select", {
    staticStyle: {
      width: "60px"
    },
    model: {
      value: _vm.item.dateEnd.unit,
      callback: function ($$v) {
        _vm.$set(_vm.item.dateEnd, "unit", $$v);
      },
      expression: "item.dateEnd.unit"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: _vm.$t("日"),
      value: "DAY"
    }
  }, [_vm._v(_vm._s(_vm.$t("日")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("月"),
      value: "MONTH"
    }
  }, [_vm._v(_vm._s(_vm.$t("月")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("年"),
      value: "YEAR"
    }
  }, [_vm._v(_vm._s(_vm.$t("年")))])], 1)], 1) : _vm._e()])])])]), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宽度限制")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择宽度")
    },
    model: {
      value: _vm.item.widthSet,
      callback: function ($$v) {
        _vm.$set(_vm.item, "widthSet", $$v);
      },
      expression: "item.widthSet"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: "10%",
      value: 10
    }
  }, [_vm._v(_vm._s(_vm.$t("10%")))]), _c("a-select-option", {
    attrs: {
      label: "20%",
      value: 20
    }
  }, [_vm._v(_vm._s(_vm.$t("20%")))]), _c("a-select-option", {
    attrs: {
      label: "30%",
      value: 30
    }
  }, [_vm._v(_vm._s(_vm.$t("30%")))]), _c("a-select-option", {
    attrs: {
      label: "40%",
      value: 40
    }
  }, [_vm._v(_vm._s(_vm.$t("40%")))]), _c("a-select-option", {
    attrs: {
      label: "50%",
      value: 50
    }
  }, [_vm._v(_vm._s(_vm.$t("50%")))]), _c("a-select-option", {
    attrs: {
      label: "60%",
      value: 60
    }
  }, [_vm._v(_vm._s(_vm.$t("60%")))]), _c("a-select-option", {
    attrs: {
      label: "70%",
      value: 70
    }
  }, [_vm._v(_vm._s(_vm.$t("70%")))]), _c("a-select-option", {
    attrs: {
      label: "80%",
      value: 80
    }
  }, [_vm._v(_vm._s(_vm.$t("80%")))]), _c("a-select-option", {
    attrs: {
      label: "90%",
      value: 90
    }
  }, [_vm._v(_vm._s(_vm.$t("90%")))]), _c("a-select-option", {
    attrs: {
      label: "100%",
      value: 100
    }
  }, [_vm._v(_vm._s(_vm.$t("100%")))])], 1)], 1)], 1)])]), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {
    staticClass: "nav_50"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()] : _vm.item.partsType === "enclosure" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.item.controlName || _vm.$t("控件名称")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item.controlExplain) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", {
    staticClass: "pictureBox"
  }, [_c("div", {
    staticClass: "ant-upload ant-upload-select ant-upload-select-picture-card picture"
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  })], 1), _c("div", [_vm.item.fileFormat.length != 0 ? _c("span", [_vm._v(" *" + _vm._s(_vm.$t("文件格式")) + "（" + _vm._s(_vm.item.fileFormat.join(",")) + "） ")]) : _vm._e(), _vm.item.fileListData.length != 0 ? _c("span", {
    on: {
      click: _vm.openModal
    }
  }, [_vm._v(_vm._s(_vm.$t("模板预览")))]) : _vm._e()]), _c("div", {
    staticClass: "nav_qain"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item.promptText)) + " ")]), _c("a-modal", {
    attrs: {
      visible: _vm.isModalVisible,
      title: _vm.$t("文件列表"),
      width: 400,
      "body-style": {
        height: "300px"
      },
      footer: null
    },
    on: {
      change: _vm.closeModal
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, _vm._l(_vm.item.fileListData, function (file) {
    return _c("a-tooltip", {
      key: file.name,
      attrs: {
        placement: "topLeft",
        title: file.name
      }
    }, [_c("a-upload", {
      staticClass: "upload_delet",
      attrs: {
        showRemoveIcon: false,
        "file-list": [file],
        "list-type": "picture-card"
      }
    })], 1);
  }), 1)])], 1)], 1), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? _c("div", [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置：")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 15
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.item, "promptText", $$v);
      },
      expression: "item.promptText"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件格式"),
      prop: "fileFormat"
    }
  }, [_c("a-checkbox-group", {
    on: {
      change: function ($event) {
        return _vm.onChangeFormat(_vm.index);
      }
    },
    model: {
      value: _vm.item.fileFormat,
      callback: function ($$v) {
        _vm.$set(_vm.item, "fileFormat", $$v);
      },
      expression: "item.fileFormat"
    }
  }, [_c("a-checkbox", {
    attrs: {
      value: "xls"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("xls")))]), _c("a-checkbox", {
    attrs: {
      value: "xlsx"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("xlsx")))]), _c("a-checkbox", {
    attrs: {
      value: "docx"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("docx")))]), _c("a-checkbox", {
    attrs: {
      value: "doc"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("doc")))]), _c("a-checkbox", {
    attrs: {
      value: "Word"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Word")))]), _c("a-checkbox", {
    attrs: {
      value: "mov"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("mov")))]), _c("a-checkbox", {
    attrs: {
      value: "mp4"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("mp4")))]), _c("a-checkbox", {
    attrs: {
      value: "rmvb"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("rmvb")))]), _c("a-checkbox", {
    attrs: {
      value: "rm"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("rm")))]), _c("a-checkbox", {
    attrs: {
      value: "avi"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("avi")))]), _c("a-checkbox", {
    attrs: {
      value: "PDF"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("PDF")))]), _c("a-checkbox", {
    attrs: {
      value: "png"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("png")))]), _c("a-checkbox", {
    attrs: {
      value: "JPG"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("JPG")))]), _c("a-checkbox", {
    attrs: {
      value: "jpeg"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("jpeg")))])], 1)], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件大小"),
      prop: "fileFormat"
    }
  }, [_c("a-input-number", {
    attrs: {
      min: 1,
      max: 1024,
      "controls-position": "right"
    },
    model: {
      value: _vm.item.fileSize.size,
      callback: function ($$v) {
        _vm.$set(_vm.item.fileSize, "size", $$v);
      },
      expression: "item.fileSize.size"
    }
  }), _c("a-select", {
    staticStyle: {
      width: "80px"
    },
    model: {
      value: _vm.item.fileSize.type,
      callback: function ($$v) {
        _vm.$set(_vm.item.fileSize, "type", $$v);
      },
      expression: "item.fileSize.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "KB"
    }
  }, [_vm._v("KB")]), _c("a-select-option", {
    attrs: {
      value: "MB"
    }
  }, [_vm._v("MB")])], 1)], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)]), _c("div", {}, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("上传多张")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.fileNumber.is_many,
      callback: function ($$v) {
        _vm.$set(_vm.item.fileNumber, "is_many", $$v);
      },
      expression: "item.fileNumber.is_many"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-input-number", {
    attrs: {
      min: 2,
      max: 10,
      "controls-position": "right",
      disabled: !_vm.item.fileNumber.is_many,
      parser: parseInt
    },
    model: {
      value: _vm.item.fileNumber.value,
      callback: function ($$v) {
        _vm.$set(_vm.item.fileNumber, "value", $$v);
      },
      expression: "item.fileNumber.value"
    }
  }), _c("a-radio", {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "flex-direction": "column"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "14px",
      color: "rgba(0, 0, 0, 0.85)"
    }
  }, [_vm._v(_vm._s(_vm.$t("模板：")))]), _c("div", {
    staticClass: "upload-row",
    staticStyle: {
      display: "flex",
      "align-items": "center",
      "margin-left": "50px"
    }
  }, [_c("a-upload", {
    attrs: {
      "list-type": "picture-card",
      action: _vm.action,
      "file-list": _vm.item.fileListData,
      "before-upload": _vm.beforeUpload,
      data: {
        module: "auditAttachment"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      mousemove: _vm.handleMouseMove,
      change: _vm.changeUploadTwo
    }
  }, [_c("div", {
    staticClass: "upload-icon"
  }, [_c("div", {
    on: {
      click: function ($event) {
        return _vm.clickPlusTWO(_vm.index);
      }
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(_vm._s(_vm.$t("上传")))])], 1)])])], 1), _c("div", [_vm._v(_vm._s(_vm.hoverFileName))])])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {
    staticClass: "nav_50"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识")
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])], 1) : _vm._e()] : _vm.item.partsType === "paragraph" ? [_c("div", {
    staticClass: "card_box card_box_dl",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index, _vm.item);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [!_vm.item.content ? _c("div", {
    staticClass: "noParagraph"
  }, [_vm._v("请输入文字")]) : _c("div", {
    staticClass: "paragraphstyle",
    style: {
      width: _vm.item.widthSet
    },
    domProps: {
      innerHTML: _vm._s(_vm.item.content)
    }
  })]), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticStyle: {
      "padding-left": "20px",
      "box-sizing": "border-box",
      overflow: "hidden"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      labelCol: {
        span: 2
      },
      labelAlign: "left"
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1), _c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      width: "72px",
      "font-weight": "bold"
    }
  }, [_vm._v("正文")]), _c("div", {
    staticStyle: {
      flex: "1"
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor2",
    staticStyle: {
      height: "400px",
      "margin-bottom": "30px"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.item.content,
      callback: function ($$v) {
        _vm.$set(_vm.item, "content", $$v);
      },
      expression: "item.content"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宽度限制")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择宽度")
    },
    model: {
      value: _vm.item.widthSet,
      callback: function ($$v) {
        _vm.$set(_vm.item, "widthSet", $$v);
      },
      expression: "item.widthSet"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: "10%",
      value: 10
    }
  }, [_vm._v(_vm._s(_vm.$t("10%")))]), _c("a-select-option", {
    attrs: {
      label: "20%",
      value: 20
    }
  }, [_vm._v(_vm._s(_vm.$t("20%")))]), _c("a-select-option", {
    attrs: {
      label: "30%",
      value: 30
    }
  }, [_vm._v(_vm._s(_vm.$t("30%")))]), _c("a-select-option", {
    attrs: {
      label: "40%",
      value: 40
    }
  }, [_vm._v(_vm._s(_vm.$t("40%")))]), _c("a-select-option", {
    attrs: {
      label: "50%",
      value: 50
    }
  }, [_vm._v(_vm._s(_vm.$t("50%")))]), _c("a-select-option", {
    attrs: {
      label: "60%",
      value: 60
    }
  }, [_vm._v(_vm._s(_vm.$t("60%")))]), _c("a-select-option", {
    attrs: {
      label: "70%",
      value: 70
    }
  }, [_vm._v(_vm._s(_vm.$t("70%")))]), _c("a-select-option", {
    attrs: {
      label: "80%",
      value: 80
    }
  }, [_vm._v(_vm._s(_vm.$t("80%")))]), _c("a-select-option", {
    attrs: {
      label: "90%",
      value: 90
    }
  }, [_vm._v(_vm._s(_vm.$t("90%")))]), _c("a-select-option", {
    attrs: {
      label: "100%",
      value: 100
    }
  }, [_vm._v(_vm._s(_vm.$t("100%")))])], 1)], 1)], 1)]), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()] : _vm.item.partsType === "sign" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.url == "" ? _c("div", {
    staticClass: "Qm_box_a"
  }, [_c("div", {
    staticClass: "singn_tit"
  }, [_vm._v(_vm._s(_vm.$t("请在下方空白区域进行签名动作，完成签名后点击[上传]按钮")))]), _c("div", {
    staticClass: "QM_tit"
  }, [_vm._v(_vm._s(_vm.$t("签名区")))]), _c("div", {
    staticClass: "but_box"
  }, [_c("a-button", {
    attrs: {
      disabled: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]), _c("a-button", {
    staticStyle: {
      "background-color": "#1890ff",
      color: "#fff"
    },
    attrs: {
      disabled: "",
      type: "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t("上传")) + " ")])], 1)]) : _c("div", {
    staticClass: "Qm_box_a"
  }, [_c("div", {
    staticClass: "singn_tit"
  }, [_vm._v(_vm._s(_vm.$t("请在下方空白区域进行签名动作，完成签名后点击[上传]按钮")))]), _c("div", {
    staticClass: "QM_tit_b"
  }, [_c("img", {
    staticClass: "img_nav",
    attrs: {
      src: _vm.item.url
    }
  })]), _c("div", {
    staticClass: "but_box"
  }, [_c("a-button", {
    attrs: {
      disabled: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]), _c("a-button", {
    staticStyle: {
      "background-color": "#1890ff",
      color: "#fff"
    },
    attrs: {
      disabled: "",
      type: "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t("上传")) + " ")])], 1)])]), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? _c("div", [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("签名区设置：")))]), _c("signModel", {
    attrs: {
      index: _vm.index,
      "form-data-array": _vm.groupDatas
    }
  }), _c("div", {
    staticClass: "btn_close",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)], 1)])], 1) : _vm._e()] : _vm.item.partsType === "table" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    staticStyle: {
      "text-align": "center"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index, _vm.item);
      }
    }
  }, [_c("table-control", {
    attrs: {
      index: _vm.index,
      containerTemplateId: _vm.item.containerTemplateId,
      containerTemplateInfo: _vm.item.containerTemplateInfo
    }
  }), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2)] : _vm.item.partsType === "payment" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index, _vm.item);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.item.controlName || _vm.$t("控件名称")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item.controlExplain) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("a-input", {
    style: {
      width: _vm.item.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.item.promptText),
      readOnly: true
    }
  }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)], 1), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置")))]), _c("div", {
    staticClass: "nav_tit",
    staticStyle: {
      "margin-left": "31px"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 500,
      disabled: ""
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.item, "promptText", $$v);
      },
      expression: "item.promptText"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {
    staticClass: "nav_item_q nav_tit"
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宽度限制")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择宽度")
    },
    model: {
      value: _vm.item.widthSet,
      callback: function ($$v) {
        _vm.$set(_vm.item, "widthSet", $$v);
      },
      expression: "item.widthSet"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: "10%",
      value: 10
    }
  }, [_vm._v(_vm._s(_vm.$t("10%")))]), _c("a-select-option", {
    attrs: {
      label: "20%",
      value: 20
    }
  }, [_vm._v(_vm._s(_vm.$t("20%")))]), _c("a-select-option", {
    attrs: {
      label: "30%",
      value: 30
    }
  }, [_vm._v(_vm._s(_vm.$t("30%")))]), _c("a-select-option", {
    attrs: {
      label: "40%",
      value: 40
    }
  }, [_vm._v(_vm._s(_vm.$t("40%")))]), _c("a-select-option", {
    attrs: {
      label: "50%",
      value: 50
    }
  }, [_vm._v(_vm._s(_vm.$t("50%")))]), _c("a-select-option", {
    attrs: {
      label: "60%",
      value: 60
    }
  }, [_vm._v(_vm._s(_vm.$t("60%")))]), _c("a-select-option", {
    attrs: {
      label: "70%",
      value: 70
    }
  }, [_vm._v(_vm._s(_vm.$t("70%")))]), _c("a-select-option", {
    attrs: {
      label: "80%",
      value: 80
    }
  }, [_vm._v(_vm._s(_vm.$t("80%")))]), _c("a-select-option", {
    attrs: {
      label: "90%",
      value: 90
    }
  }, [_vm._v(_vm._s(_vm.$t("90%")))]), _c("a-select-option", {
    attrs: {
      label: "100%",
      value: 100
    }
  }, [_vm._v(_vm._s(_vm.$t("100%")))])], 1)], 1)], 1), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      "margin-left": "20px",
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e()]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)])]), _c("div", {
    staticClass: "nav_50",
    staticStyle: {
      display: "flex",
      "margin-left": "48px"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识")
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1)]), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()] : _vm.item.partsType === "estimate" ? [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index, _vm.item);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.item.controlName || _vm.$t("控件名称")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.item.controlExplain) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("a-input", {
    style: {
      width: _vm.item.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.item.promptText),
      readOnly: true
    }
  }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)], 1), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupItem: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.groupDatas,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置")))]), _c("div", {
    staticClass: "nav_tit",
    staticStyle: {
      "margin-left": "31px"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 500,
      disabled: ""
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.item, "promptText", $$v);
      },
      expression: "item.promptText"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {
    staticClass: "nav_item_q nav_tit"
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宽度限制")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "280px"
    },
    attrs: {
      placeholder: _vm.$t("请选择宽度")
    },
    model: {
      value: _vm.item.widthSet,
      callback: function ($$v) {
        _vm.$set(_vm.item, "widthSet", $$v);
      },
      expression: "item.widthSet"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: "10%",
      value: 10
    }
  }, [_vm._v(_vm._s(_vm.$t("10%")))]), _c("a-select-option", {
    attrs: {
      label: "20%",
      value: 20
    }
  }, [_vm._v(_vm._s(_vm.$t("20%")))]), _c("a-select-option", {
    attrs: {
      label: "30%",
      value: 30
    }
  }, [_vm._v(_vm._s(_vm.$t("30%")))]), _c("a-select-option", {
    attrs: {
      label: "40%",
      value: 40
    }
  }, [_vm._v(_vm._s(_vm.$t("40%")))]), _c("a-select-option", {
    attrs: {
      label: "50%",
      value: 50
    }
  }, [_vm._v(_vm._s(_vm.$t("50%")))]), _c("a-select-option", {
    attrs: {
      label: "60%",
      value: 60
    }
  }, [_vm._v(_vm._s(_vm.$t("60%")))]), _c("a-select-option", {
    attrs: {
      label: "70%",
      value: 70
    }
  }, [_vm._v(_vm._s(_vm.$t("70%")))]), _c("a-select-option", {
    attrs: {
      label: "80%",
      value: 80
    }
  }, [_vm._v(_vm._s(_vm.$t("80%")))]), _c("a-select-option", {
    attrs: {
      label: "90%",
      value: 90
    }
  }, [_vm._v(_vm._s(_vm.$t("90%")))]), _c("a-select-option", {
    attrs: {
      label: "100%",
      value: 100
    }
  }, [_vm._v(_vm._s(_vm.$t("100%")))])], 1)], 1)], 1), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      "margin-left": "20px",
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e()]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)])]), _c("div", {
    staticClass: "nav_50",
    staticStyle: {
      display: "flex",
      "margin-left": "48px"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识")
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1)]), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.formClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()] : _vm._e(), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["avi", "mov", "rm", "mp4", "rmvb"],
      fileList: _vm.dataForm.fileList,
      show: _vm.isShow,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }), _vm.containerVisible ? _c("add-table-control-model", {
    ref: "addTableModel",
    attrs: {
      tableMark: _vm.tableMark,
      containerVisible: _vm.containerVisible
    },
    on: {
      "update:containerVisible": function ($event) {
        _vm.containerVisible = $event;
      },
      "update:container-visible": function ($event) {
        _vm.containerVisible = $event;
      },
      openDesign: _vm.openDesign
    }
  }) : _vm._e(), _c("table-design-model", {
    attrs: {
      tableDesignModelVisible: _vm.tableDesignModelVisible,
      tableId: _vm.tableId
    },
    on: {
      "update:tableDesignModelVisible": function ($event) {
        _vm.tableDesignModelVisible = $event;
      },
      "update:table-design-model-visible": function ($event) {
        _vm.tableDesignModelVisible = $event;
      },
      saveTableData: _vm.saveTableData
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };